import React, { useEffect, useRef, useState } from 'react'
import { registerLocale } from 'react-datepicker'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { getLOVExpediente, setValorCampoExpediente } from '../../actions/expedientes'

import es from 'date-fns/locale/es'
import i18n from '../../lang/idiomas'

registerLocale('es', es)

let filtros_procesados = []
let prev_filtros_proc
let valores
let filtros_keys

const Selector = props => {
  const dispatch = useDispatch()

  const selectRef = useRef(null)
  const [selected, setSelected] = useState(null)
  const [listaFiltrada, setListaFiltrada] = useState({})
  const [index, setIndex] = useState(-1)

  const tipos_expedientes = useSelector(state => state.expedientes.tipos_expedientes)
  const tipo_expediente_seleccionado = useSelector(
    state => state.expedientes.tipo_expediente_seleccionado,
  )
  const tipos_expedientes_campos = useSelector(state => state.expedientes.tipos_expedientes_campos)
  const isValidating = useSelector(state => state.expedientes.isValidating)
  const lov = useSelector(state => state.expedientes.valores_lovs)

  useEffect(() => {
    let ind_campo = -1
    // Recuperamos el indice del campo
    ind_campo = tipos_expedientes_campos.findIndex(campo => campo.columna === props.campo.columna)
    setIndex(ind_campo)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // Recuperamos la lista de valores a mostrar
    if (lov?.length > 0) {
      setListaFiltrada(
        lov.filter(
          lista_valores =>
            lista_valores.tipo_expediente ===
              tipos_expedientes[tipo_expediente_seleccionado].tipo_expediente &&
            lista_valores.codigo_lov === props.campo.codigo_lov &&
            lista_valores.campo === props.campo.columna,
        )[0],
      )
    }
    // Si el campo no está en el array de filtros lo inicializamos
    if (!([props.campo.columna] in props.filtros)) {
      props.handleChange(props.campo.columna, null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  })

  const procesaDatos = e => {
    // Funcion que carga datos al entrar en el campo
    e.preventDefault()
    // Comprobamos que se ha seteado el valor previamente
    if (valores) {
      // Cargamos los valores actuales en las variables
      procesarValores(e)
      // Si ambas variables tienen carga
      if (prev_filtros_proc && filtros_procesados) {
        let pedir = false
        //Buscamos la lista en cuestion
        let lista = lov.filter(
          lista_valores =>
            lista_valores.tipo_expediente ===
              tipos_expedientes[tipo_expediente_seleccionado].tipo_expediente &&
            lista_valores.codigo_lov === props.campo.codigo_lov &&
            lista_valores.campo === props.campo.columna,
        )[0]
        // Pedimos si no coincide longitud o no hay datos
        if (
          prev_filtros_proc.length !== filtros_procesados.length ||
          !lista?.data ||
          lista.data.length === 0
        ) {
          pedir = true
        } else {
          // Recuperamos el campo correspondiente a LV
          let campo_buscado = tipos_expedientes_campos.filter(
            campo_buscado => campo_buscado.columna === props.campo.columna,
          )[0]
          if (campo_buscado) {
            for (let campo_aux of tipos_expedientes_campos) {
              // Si son anteriores a la LV
              if (campo_aux.orden < campo_buscado.orden) {
                // Recuperamos el indice del array de filtros
                let indice_filtro_campo_aux = prev_filtros_proc.findIndex(
                  filtro => filtro.codigo === campo_aux.columna,
                )
                //Comparamos valores previos y actuales
                if (indice_filtro_campo_aux !== -1) {
                  if (
                    prev_filtros_proc[indice_filtro_campo_aux].valor !==
                    filtros_procesados[indice_filtro_campo_aux].valor
                  ) {
                    pedir = true
                  }
                }
              }
            }
          }
        }
        if (pedir) {
          // Llamamos a LISA para cargar los datos
          cargaDatos()
        }
      }
    } else {
      // Cargamos los valores actuales en las variables
      procesarValores(e)
      // Llamamos a LISA para cargar los datos
      cargaDatos()
    }
  }

  const procesarValores = e => {
    //Limpiamos el array
    filtros_procesados = []
    valores = { ...props.filtros }

    //Eliminamos  valores innecesarios
    delete valores['filesAux']
    delete valores['fileInput']

    filtros_keys = Object.keys(valores)

    // Cargamos el array de filtros
    filtros_keys.forEach(codigo => {
      filtros_procesados.push({
        codigo: codigo,
        valor: props.filtros[codigo] ? props.filtros[codigo] : '',
      })
    })
  }

  const cargaDatos = () => {
    // Cargamos los valores actuales a la variable de previos
    prev_filtros_proc = filtros_procesados
    dispatch(
      getLOVExpediente(
        tipos_expedientes[tipo_expediente_seleccionado].tipo_expediente,
        props.campo.codigo_lov,
        props.campo.columna,
        filtros_procesados,
      ),
    )
  }

  const handleBlur = e => {
    e.preventDefault()

    if (index !== -1) {
      // Cargamos el valor guardado en el estado local al redux
      if (selected && selected !== tipos_expedientes_campos[index].valor) {
        dispatch(setValorCampoExpediente(props.campo.columna, selected))
        props.handleChange(props.campo.columna, selected)
      }
    }
  }

  const handleChange = e => {
    if (e !== null && (e.length === undefined || e?.length > 0)) {
      let valor_aux
      let d_aux
      // Recuperamos el indice del campo
      if (props.campo.tipo_lov === 'M') {
        for (let valor of e) {
          if (valor_aux) {
            valor_aux = valor_aux + ',' + valor.value
            d_aux = d_aux + ',' + valor.label
          } else {
            valor_aux = valor.value
            d_aux = valor.label
          }
        }
      } else {
        valor_aux = e?.value || ''
        d_aux = e?.label || ''
      }
      if (index !== -1) {
        if (tipos_expedientes_campos[index].valor !== valor_aux) {
          // Cargamos estado local
          setSelected(valor_aux)
          // Cargamos estado del redux
          dispatch(setValorCampoExpediente(props.campo.columna, valor_aux, d_aux))
          // Cargamos estado padre ( Completar el array de filtros del resto de campos )
          props.handleChange(props.campo.columna, valor_aux)
        }
      }
    }
  }

  if (
    selected &&
    tipos_expedientes_campos[index].valor === '' &&
    selected !== tipos_expedientes_campos[index].valor
  ) {
    if (selectRef?.current?.props?.value?.[0]?.value || selectRef?.current?.props?.value?.value) {
      setSelected('')
      selectRef?.current?.clearValue()
    }
  }

  return (
    <div
      className='form-group selector'
      key={props.index}>
      <label
        className={
          props.origen === 'expedientes'
            ? props.campo.desactivado === 'S'
              ? 'campo-expediente-label-disabled'
              : 'campo-expediente-label'
            : ''
        }
        htmlFor={props.campo.columna}>
        {props.campo.literal}
      </label>
      {listaFiltrada?.data?.length > 0 ? (
        <Select
          ref={selectRef}
          id={props.campo.columna}
          key={props.campo.columna + '-' + props.campo.orden}
          style={props.campo.ancho ? { width: props.campo.ancho } : null}
          onFocus={procesaDatos}
          onChange={handleChange}
          onBlur={handleBlur}
          isMulti={props.campo.tipo_lov === 'M'}
          options={listaFiltrada?.data ? listaFiltrada.data : []}
          isLoading={listaFiltrada?.loading ? listaFiltrada.loading : ''}
          loadingMessage={() => i18n.t('expedientes.excardat')}
          noOptionsMessage={() => i18n.t('expedientes.exnoseen')}
          placeholder={i18n.t('expedientes.exselna')}
          isClearable
          isDisabled={!!(isValidating || props.campo.desactivado === 'S')}
        />
      ) : (
        <Select
          id={props.campo.columna}
          key={props.campo.columna + '-' + props.campo.orden}
          style={props.campo.ancho ? { width: props.campo.ancho } : null}
          onFocus={procesaDatos}
          options={[]}
          isMulti={props.campo.tipo_lov === 'M'}
          onBlur={handleBlur}
          isLoading={listaFiltrada?.loading ? listaFiltrada.loading : ''}
          loadingMessage={() => i18n.t('expedientes.excardat')}
          noOptionsMessage={() => i18n.t('expedientes.exnoseen')}
          placeholder={i18n.t('expedientes.exselna')}
          value={i18n.t('expedientes.exselna')}
          isDisabled={!!(isValidating || props.campo.desactivado === 'S')}
        />
      )}
    </div>
  )
}

export default Selector
